
<div>
  <slot></slot>
  <p v-if="objectModelAction.linked_document_id">
    {{ objectModelAction.linked_document_title }}
  </p>
  <p v-else>
    Choose a document...
  </p>
</div>
